import React from 'react';

import { Circle, Line, LabelContainer, CircleContainer, Label, Time } from './style';

export default ({ label = '', time = '', isLast = false, show = false, isCompleted = false }) => (
    <React.Fragment>

        <CircleContainer>
            <Circle isActive={show} isCompleted={isCompleted} />
            <LabelContainer visible={show}>
                <Label>{label}</Label>
                <Time>{time}</Time>
            </LabelContainer>
        </CircleContainer>
        
        { !isLast ? <Line isCompleted={isCompleted} /> : null }

    </React.Fragment>
);